module.exports = __webpack_public_path__ + "img/1.dd4a13aa.png";